// USE
// ADD oninput="handleEmailMatch()" to email and email matcher inputs
// ADD attribute gdc-js-email-to-match to the main email input
// ADD attribute gdc-js-email-matcher to the matcher email input
// ADD attribute gdc-js-button-submit to the form submit button
// CONFIRM there is a <label> within a parent div for each email input

const getLabel = (elem) => elem.closest('div').querySelector('label')
const submitButton = () => document.querySelector('[gdc-js-button-submit]')
const emailInput = () => document.querySelector('[gdc-js-email-to-match]')
const matcherInput = () => document.querySelector('[gdc-js-email-matcher]')
const email = () => emailInput().value
const matcher = () => matcherInput().value
const emailsMatch = () => email() === matcher()

function setEmailError() {
  submitButton().setAttribute('disabled', '')
  getLabel(emailInput()).classList.add('email-match-error')
  getLabel(matcherInput()).classList.add('email-match-error')
  submitButton().classList.add('email-match-error')
}

function removeEmailError() {
  submitButton().removeAttribute('disabled')
  getLabel(emailInput()).classList.remove('email-match-error')
  getLabel(matcherInput()).classList.remove('email-match-error')
  submitButton().classList.remove('email-match-error')
}

function handleEmailMatch() {
  console.log('called')
  emailsMatch() ? removeEmailError() : setEmailError()
}
